import { normalizeString } from './common'

const sommaire = document.querySelector('.sommaire')
const list = document.querySelector('.sommaire .list')
const content = document.querySelector('.vp-main')
if (sommaire && list && content) {
  const headings = content.querySelectorAll('h2')
  if (headings.length > 0) {
    const url =
      document.location.protocol +
      '//' +
      document.location.host +
      document.location.pathname +
      document.location.search
    for (const heading of content.querySelectorAll('h2')) {
      const text = heading.textContent
      const id = normalizeString(heading.textContent)
        .replace(/[^a-z0-9_]+/gi, '-')
        .replace(/^-|-$/g, '')
      heading.setAttribute('id', id)
      const link = document.createElement('a')
      link.textContent = text
      link.href = url + '#' + id
      link.classList.add(
        'vp-link-alt',
        'level-' + heading.tagName.toLowerCase()
      )
      list.appendChild(link)
    }
  } else {
    sommaire.style.display = 'none'
  }
}
